import { defineStore } from 'pinia';

import * as state from './team.state';
import * as getters from './team.getters';
import * as actions from './team.actions';

export const useTeamStore = defineStore('team', () => ({
  ...state,
  ...getters,
  ...actions
}));
